import { GetListOperation, PostOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

/**
 * Отклик поставщика (ТЗ 4.2): черновик — создание, правка, удаление; отправленный отклик —
 * правка с необязательной причиной, отзыв, подтверждение, история записей по отклику.
 * Сгенерировано Claude.
 */
export default class SpecOfferApi extends BaseApi {
  static entityName = 'spec_offers';

  /** Отозвать отклик (ТЗ 4.2, условия — 2.5). */
  withdraw(id, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/withdraw`, {});
    return this.execute(operation, withPreloader);
  }

  /** Подтвердить отклик по позиции «Утверждено заказчиком» (ТЗ 4.2). */
  confirm(id, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/confirm`, {});
    return this.execute(operation, withPreloader);
  }

  /** История одного отклика: изменения полей с причиной и смены состояния (ТЗ 4.2, 6.5). */
  fetchHistory(id, withPreloader = false) {
    const operation = new GetListOperation(`${this.getIri(id)}/history`);
    return this.execute(operation, withPreloader);
  }
}
